export const enum CaseStatus {
  OPEN = 'OPEN',

  READY_FOR_PAYMENT = 'READY_FOR_PAYMENT',

  PENDING_PAYMENT = 'PENDING_PAYMENT',

  FOLLOW_UP = 'FOLLOW_UP',

  CLOSED = 'CLOSED',

  UNQUALIFIED = 'UNQUALIFIED',
}
